(() => {
  'use strict';
  if (!document.documentElement.lang.toLowerCase().startsWith('de')) return;
  const labels = {
    'Close cart': 'Warenkorb schließen',
    'Decrease quantity': 'Menge verringern',
    'Increase quantity': 'Menge erhöhen',
    'Product quantity': 'Artikelmenge',
    'Remove item': 'Artikel entfernen',
    'Original price': 'Ursprünglicher Preis',
    'Sale price': 'Angebotspreis',
    'Savings': 'Ersparnis',
    'Total savings': 'Gesamtersparnis',
    'Size': 'Größe',
    'Color': 'Farbe'
  };
  let connected = false;
  function translate(root) {
    root.querySelectorAll('[aria-label], [title], [placeholder]').forEach(element => {
      ['aria-label', 'title', 'placeholder'].forEach(attribute => {
        const value = element.getAttribute(attribute);
        if (labels[value]) element.setAttribute(attribute, labels[value]);
      });
    });
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement?.closest('script, style')) continue;
      const value = node.nodeValue.trim();
      if (labels[value]) node.nodeValue = node.nodeValue.replace(value, labels[value]);
    }
  }
  function connect() {
    if (connected) return true;
    const root = document.getElementById('upCart')?.shadowRoot;
    if (!root) return false;
    connected = true;
    translate(root);
    let pending = false;
    new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => {
        pending = false;
        translate(root);
      });
    }).observe(root, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['aria-label','title','placeholder']});
    return true;
  }
  if (!connect()) {
    let attempts = 0;
    const timer = setInterval(() => {
      if (connect() || ++attempts >= 30) clearInterval(timer);
    }, 500);
  }
})();
